import VoicesSettings from "../Components/Voices/Settings/VoicesSettings";

const VoicesSettingsPage = () => {
  return <VoicesSettings />;
};

export default VoicesSettingsPage;
